"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.form.title.edit': '编辑用户组',
    'userGroup.form.title.add': '添加用户组',
    'userGroup.form.back': '返回',
    'userGroup.form.name.label': '组名',
    'userGroup.form.name.placeholder': '输入组名',
    'userGroup.form.description.label': '描述',
    'userGroup.form.description.placeholder': '输入组描述',
    'userGroup.form.active.label': '活跃',
    'userGroup.form.acl.label': '访问控制',
    'userGroup.form.acl.description': '为此用户组配置访问权限',
    'userGroup.form.submit.update': '更新用户组',
    'userGroup.form.submit.create': '创建用户组',
    'userGroup.form.saved': '用户组已成功保存',
    'userGroup.form.error.save': '保存用户组失败',
};
